<template>
  <v-container id="page-drive-schedule">
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-col cols="12" class="mt-5">
        <c-card>
          <v-sheet
            tile
            height="54"
            color="white"
            class="text-center"
            style="font-size: 15px"
          >
            <c-btn iconName="mdi-chevron-left" text @click="$refs.calendar.prev()" class="ma-2"></c-btn>
            <span class="text-center"> {{ $refs.calendar? this.$moment($refs.calendar.renderProps.start.date).format('YYYY년 - MM월') : this.today.format('YYYY년 - MM월')}}</span>
            <c-btn iconName="mdi-chevron-right" text @click="$refs.calendar.next()" class="ma-2"></c-btn>
          </v-sheet>
          <v-sheet height="600">
            <v-calendar
              ref="calendar"
              v-model="value"
              :weekdays="weekdays"
              type="month"
              :events="events"
              :event-color="getEventColor"
              @change="reqDriveSchedule"
              @click:event="onUpdateSchedule"
              @click:date="onSettingSchedule"
              locale="ko"
              color="success"
            ></v-calendar>
          </v-sheet>
        </c-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        value: '',
        events: [],
        today : this.$moment(),
        start : '',
        weekdays : [1, 2, 3, 4, 5, 6, 0],
      }
    },
    methods: {
      async onSettingSchedule({date}) {
        // 예약설정이 아예 안되있는 경우, 날짜버튼 클릭시 예약 페이지로 이동
        this.$router.push(`/driveSchedule/${date}`);
      },

      async reqDriveSchedule({ start, end }) {
        // v-calendar는 기본적으로, 하나의 큰 table를 load해놓고, month의 변화에 따라 일부를 출력해주는 구조이다.
        // 따라서, 8월에 가져왔던 7월 && 9월의 정보를 event array에 계속 가지고 있기 때문에,
        // 9월로 넘어갈 때 위의 첫 행만 바로 load 된다. 이를 방지하기 위해서, events를 비워주어야 한다.
        this.events = [];
        let beforePrintDate;
        let afterPrintDate;
        const events = [];
        let apiResponse = {};
        let otherapiResponse = {};

        try {
          if(start.weekday === 0) beforePrintDate = this.$func.dateStringAddDays(start.date, -6);
          else beforePrintDate = this.$func.dateStringAddDays(start.date, (start.weekday-1) *-1);
          if(end.weekday === 0) afterPrintDate = this.$func.dateToString(end.date);
          else afterPrintDate = this.$func.dateStringAddDays(end.date, 7 - end.weekday);

          const res = await this.$api.getPeriodDriveSchedule(beforePrintDate, afterPrintDate);
          const currentDriverData = await this.$api.getDailyDriveSchedule(this.$moment(start.date).format('YYYY-MM'));

          let totalNumOfBlock = 0;
          for (let i = 0; i < currentDriverData.data.length; i++) {
            totalNumOfBlock += currentDriverData.data[i].vehicleList.length;
          }

          apiResponse = res.data;
          let printDate = {};

          // 5일 이내의 날짜 체크
          let validDays = [];
          for(let i=1; i<6; i++) {
            validDays.push(this.$func.curDateStringAddDays(i));
          }

          const dailyDuration = this.$moment.duration(this.$moment(afterPrintDate).diff(this.$moment(beforePrintDate))).asDays()

          Array.from({length: dailyDuration}).forEach((_, index) => {
            const date = this.$func.dateStringAddDays(beforePrintDate, index);
            const diffDays = this.$moment.duration(this.$moment(date).diff(this.$moment())).asDays();
            const count = apiResponse[date] || 0

            let title = '';
            let bgColor = '';

            if(diffDays < -1){
              title = '운행종료';
              bgColor = 'light2Grey'
            } else {
              if (count === 0) {
                title = '미입력';
                bgColor = 'light1Red';
              }
              else if(count === totalNumOfBlock) {
                title = '입력완료 ';
                // bgColor= 'blue';
                bgColor= 'dark3Grey';
              } else {
                title = "입력중"
                bgColor = "light1Blue"
              }
            }

            events.push({
              name: title,
              start: date,
              color : bgColor
            })
          })
          this.events = events;
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqDriveSchedule'});
        }
      },
      getEventColor (event) {
        return event.color
      },
      onUpdateSchedule({ nativeEvent, event }) {
        this.$router.push(`/driveSchedule/${event.start}`);
      },
      setColor() {
        const allweekends = document.querySelectorAll(".v-calendar-weekly__head-weekday")
        const alldays = document.querySelectorAll(".v-calendar-weekly__week")
        const sat = this.weekdays.indexOf(6)
        const sun = this.weekdays.indexOf(0)

        allweekends[sat].style.color = 'blue';
        allweekends[sun].style.color = 'red';

        alldays.forEach((x) => {
          if(x.children) {
            if(x.children[sat]) {
              const targetEleSat = x.children[sat].children[0].children[0]
              targetEleSat.style.color = "blue";
            }
            if(x.children[sun]) {
              const targetEleSun = x.children[sun].children[0].children[0]
              targetEleSun.style.color = "red";
            }
          }
        });
      },
    },
    updated() {
      this.setColor();
    },
    activated() {
      this.reqDriveSchedule(this.$refs.calendar.renderProps);
    }
  }
</script>

<style scoped>

</style>
